import React, { Component } from 'react';
import Content from '../_core/components/Content';
import Link from '../_core/components/Link';

class Index extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}


	/*

		RENDER

	*/

	render() {

		


		return (

			<div className="Template Template--error">
			<div className="Template-body">
				<Content>
					<h3>Page not found</h3>
					<p>We can't seem to find that page. It may have moved, please try our <a href="/">home page</a> instead</p>
				</Content>
				<div className="Template-back"><Link to={'/'}>&larr; Back to home</Link></div>
			</div>
			</div>

		);

	}
}

export default Index;



// WEBPACK FOOTER //
// ./src/js/templates/error.js